import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../app/AuthContext";
import { safeHttpUrl } from "../lib/safeUrl";

interface CandidateRow {
  id: string;
  input_url: string;
  suggested_name: string | null;
  status: string;
  created_at: string;
}

export function AdminCandidatesPage() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const status = params.get("status") ?? "review";
  const [items, setItems] = useState<CandidateRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.admin.candidates(status)
      .then((r) => setItems(r.items as CandidateRow[]))
      .finally(() => setLoading(false));
  }, [status]);

  if (!user || (user.role !== "admin" && user.role !== "super_admin")) {
    return <div className="container empty-state">Admin access required.</div>;
  }

  return (
    <div className="container" style={{ paddingBlock: "2rem" }}>
      <h2>Candidates — {status}</h2>
      {loading ? <div className="empty-state">Loading…</div> : (
        <div className="admin-table-wrap"><table className="admin-table" style={{ marginTop: "1.5rem" }}>
          <thead>
            <tr>
              <th>Suggested name</th>
              <th>URL</th>
              <th>Status</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id}>
                <td>{c.suggested_name ?? "—"}</td>
                <td><SafeExternalLink url={c.input_url} /></td>
                <td>{c.status}</td>
                <td>{new Date(c.created_at).toLocaleDateString()}</td>
                <td><Link to={`/admin/candidates/${c.id}`}>Review →</Link></td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: "center", color: "var(--fg-subtle)", paddingBlock: "2rem" }}>No candidates.</td></tr>
            )}
          </tbody>
        </table></div>
      )}
    </div>
  );
}

function SafeExternalLink({ url }: { url: string | null }) {
  const safe = safeHttpUrl(url);
  return safe ? <a href={safe} target="_blank" rel="noreferrer">{url}</a> : <span>{url ?? "—"}</span>;
}
